export default "/images/double-check.png?c7623720e61abe57b33287a76f12c3e2";